import React from 'react';
import styled from '@nykaa/ui-components/styles/styled';
const Count = styled.div `
  ${({ theme }) => theme.typography.bodySmall};
  color: #757575;
  margin: ${({ theme }) => theme.spacing.spacing0};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  padding: ${({ theme: { spacing } }) => `${spacing.spacing0}`};
  text-transform: capitalize;
`;
const VariantsCount = ({ variantType, variantCount = 100, isTranslated = false, }) => {
    if (!variantCount || !variantType) {
        return null;
    }
    let customVariant = '';
    if (!isTranslated) {
        customVariant = variantCount > 1 ? `${variantType}s` : variantType;
    }
    return (React.createElement(Count, null,
        variantCount,
        ' ',
        customVariant || variantType));
};
export default VariantsCount;
